import REQ, { combineReqs, ReqType } from '../../utils/REQ';
import Loader from '../../_common/components/loader/Loader';
import ErrorMessage from '../../_common/components/error-message/ErrorMessage';
import { useTranslation } from 'react-i18next';
import PageHeader from '@components/page-header/PageHeader';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../_common/hooks/reduxHooks';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  req?: ReqType | ReqType[];
}>;

// For use within a Page component only!
export const ContentLoader = ({ req, children }: Props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { userId, userRole } = useAppSelector(({ auth }) => ({
    userId: auth._id,
    userRole: auth._type
  }));

  const combinedStatus = Array.isArray(req) ? combineReqs(req) : req;

  switch (combinedStatus) {
    case REQ.INIT:
    case REQ.PENDING:
      return <Loader />;
    case REQ.NOT_FOUND:
      return (
        <PageHeader
          headerText={t('common:pageNotFound')}
          subTitle={t('common:goBack')}
        />
      );
    case REQ.ERROR:
      return (
        <ErrorMessage
          error={
            new Error('Page could not load - REQ.ERROR!', {
              cause: {
                userId,
                userRole,
                pathname: location.pathname,
                search: location.search
              }
            })
          }
        />
      );
    default:
      return <>{children}</>;
  }
};
